require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.array.reduce");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.function.bind");

var $CLJS = require("./cljs_env");

var $jscomp = $CLJS.$jscomp;
var COMPILED = false;

require("./cljs.core.js");

require("./promesa.protocols.js");

require("./promesa.exec.js");

require("./promesa.impl.js");

var edn_query_language = $CLJS.edn_query_language || ($CLJS.edn_query_language = {});
var module$shadow_js_shim_module$react = $CLJS.module$shadow_js_shim_module$react || ($CLJS.module$shadow_js_shim_module$react = {});
var clojure = $CLJS.clojure || ($CLJS.clojure = {});
var cljs = $CLJS.cljs || ($CLJS.cljs = {});
var shadow = $CLJS.shadow || ($CLJS.shadow = {});
var module$shadow_js_shim_module$react_dom = $CLJS.module$shadow_js_shim_module$react_dom || ($CLJS.module$shadow_js_shim_module$react_dom = {});
var helix = $CLJS.helix || ($CLJS.helix = {});
var goog = $CLJS.goog || ($CLJS.goog = {});
var module$shadow_js_shim_module$$nivo$line = $CLJS.module$shadow_js_shim_module$$nivo$line || ($CLJS.module$shadow_js_shim_module$$nivo$line = {});
var expound = $CLJS.expound || ($CLJS.expound = {});
var module$shadow_js_shim_module$$nivo$bar = $CLJS.module$shadow_js_shim_module$$nivo$bar || ($CLJS.module$shadow_js_shim_module$$nivo$bar = {});
var cljs_bean = $CLJS.cljs_bean || ($CLJS.cljs_bean = {});
var promesa = $CLJS.promesa || ($CLJS.promesa = {});
var com = $CLJS.com || ($CLJS.com = {});
$CLJS.SHADOW_ENV.setLoaded("promesa.core.js");
goog.provide('promesa.core');
/**
 * Return a resolved promise with provided value.
 */

promesa.core.resolved = function promesa$core$resolved(v) {
  return promesa.impl.resolved(v);
};
/**
 * Return a rejected promise with provided reason.
 */


promesa.core.rejected = function promesa$core$rejected(v) {
  return promesa.impl.rejected(v);
};
/**
 * Creates an empty promise instance.
 */


promesa.core.deferred = function promesa$core$deferred() {
  return promesa.impl.deferred();
};
/**
 * The coerce based promise constructor. Creates a appropriate promise
 *   instance depending on the provided value.
 * 
 *   If an executor is provided, it will be used to resolve this
 *   promise.
 */


promesa.core.promise = function promesa$core$promise(var_args) {
  var G__24018 = arguments.length;

  switch (G__24018) {
    case 1:
      return promesa.core.promise.cljs$core$IFn$_invoke$arity$1(arguments[0]);
      break;

    case 2:
      return promesa.core.promise.cljs$core$IFn$_invoke$arity$2(arguments[0], arguments[1]);
      break;

    default:
      throw new Error(["Invalid arity: ", cljs.core.str.cljs$core$IFn$_invoke$arity$1(arguments.length)].join(''));
  }
};

promesa.core.promise.cljs$core$IFn$_invoke$arity$1 = function (v) {
  return promesa.protocols._promise(v);
};

promesa.core.promise.cljs$core$IFn$_invoke$arity$2 = function (v, executor) {
  return promesa.protocols._map(promesa.protocols._promise(v), cljs.core.identity, executor);
};

promesa.core.promise.cljs$lang$maxFixedArity = 2;
/**
 * A convenience alias for `promise` coercion function that only accepts
 *   a single argument.
 */

promesa.core.wrap = function promesa$core$wrap(v) {
  return promesa.protocols._promise(v);
};
/**
 * Create a promise instance from a factory function. If an executor is
 *   provided, the factory will be executed in the provided executor.
 * 
 *   A factory function looks like `(fn [resolve reject] (resolve 1))`.
 */


promesa.core.create = function promesa$core$create(var_args) {
  var G__24024 = arguments.length;

  switch (G__24024) {
    case 1:
      return promesa.core.create.cljs$core$IFn$_invoke$arity$1(arguments[0]);
      break;

    case 2:
      return promesa.core.create.cljs$core$IFn$_invoke$arity$2(arguments[0], arguments[1]);
      break;

    default:
      throw new Error(["Invalid arity: ", cljs.core.str.cljs$core$IFn$_invoke$arity$1(arguments.length)].join(''));
  }
};

promesa.core.create.cljs$core$IFn$_invoke$arity$1 = function (f) {
  var d = promesa.impl.deferred();

  try {
    var G__24026_24184 = function G__24026_24184(p1__24019_SHARP_) {
      return promesa.protocols._resolve_BANG_(d, p1__24019_SHARP_);
    };

    var G__24027_24185 = function G__24027_24185(p1__24020_SHARP_) {
      return promesa.protocols._reject_BANG_(d, p1__24020_SHARP_);
    };

    f.cljs$core$IFn$_invoke$arity$2 ? f.cljs$core$IFn$_invoke$arity$2(G__24026_24184, G__24027_24185) : f.call(null, G__24026_24184, G__24027_24185);
  } catch (e24025) {
    var e_24186 = e24025;

    promesa.protocols._reject_BANG_(d, e_24186);
  }

  return d;
};

promesa.core.create.cljs$core$IFn$_invoke$arity$2 = function (f, executor) {
  var d = promesa.impl.deferred();
  promesa.exec.run_BANG_.cljs$core$IFn$_invoke$arity$2(executor, function () {
    try {
      var G__24029 = function G__24029(p1__24021_SHARP_) {
        return promesa.protocols._resolve_BANG_(d, p1__24021_SHARP_);
      };

      var G__24030 = function G__24030(p1__24022_SHARP_) {
        return promesa.protocols._reject_BANG_(d, p1__24022_SHARP_);
      };

      return f.cljs$core$IFn$_invoke$arity$2 ? f.cljs$core$IFn$_invoke$arity$2(G__24029, G__24030) : f.call(null, G__24029, G__24030);
    } catch (e24028) {
      var e = e24028;
      return promesa.protocols._reject_BANG_(d, e);
    }
  });
  return d;
};

promesa.core.create.cljs$lang$maxFixedArity = 2;
/**
 * Return true if `v` is a promise instance.
 */

promesa.core.promise_QMARK_ = function promesa$core$promise_QMARK_(v) {
  if (!(v == null)) {
    if (false || cljs.core.PROTOCOL_SENTINEL === v.promesa$protocols$IPromise$) {
      return true;
    } else {
      if (!v.cljs$lang$protocol_mask$partition$) {
        return cljs.core.native_satisfies_QMARK_(promesa.protocols.IPromise, v);
      } else {
        return false;
      }
    }
  } else {
    return cljs.core.native_satisfies_QMARK_(promesa.protocols.IPromise, v);
  }
};
/**
 * Return true if `v` is a promise instance (alias to `promise?`).
 */


promesa.core.deferred_QMARK_ = function promesa$core$deferred_QMARK_(v) {
  return v instanceof promesa.impl._STAR_default_promise_STAR_;
};
/**
 * Returns true if `v` is a promise like object.
 */


promesa.core.thenable_QMARK_ = function promesa$core$thenable_QMARK_(v) {
  return cljs.core.object_QMARK_(v) && cljs.core.fn_QMARK_(v["then"]);
};
/**
 * Returns true if promise `p` is already fulfilled.
 */


promesa.core.resolved_QMARK_ = function promesa$core$resolved_QMARK_(p) {
  return promesa.protocols._resolved_QMARK_(p);
};
/**
 * Returns true if promise `p` is already rejected.
 */


promesa.core.rejected_QMARK_ = function promesa$core$rejected_QMARK_(p) {
  return promesa.protocols._rejected_QMARK_(p);
};
/**
 * Returns true if promise `p` is stil pending.
 */


promesa.core.pending_QMARK_ = function promesa$core$pending_QMARK_(p) {
  return promesa.protocols._pending_QMARK_(p);
};
/**
 * Returns the current promise value.
 */


promesa.core.extract = function promesa$core$extract(p) {
  return promesa.protocols._extract(p);
};
/**
 * Returns true if promise `p` is already done.
 */


promesa.core.done_QMARK_ = cljs.core.complement(promesa.core.pending_QMARK_);
/**
 * Chains a computation `f` (function) to be executed when the promise
 *   `p` is successfully resolved.
 * 
 *   The computation will be executed in the calling thread by default;
 *   you also can provide a custom executor.
 * 
 *   If the function `f` returns a promise instance, it will be
 *   automatically unwrapped.
 */

promesa.core.then = function promesa$core$then(var_args) {
  var G__24036 = arguments.length;

  switch (G__24036) {
    case 2:
      return promesa.core.then.cljs$core$IFn$_invoke$arity$2(arguments[0], arguments[1]);
      break;

    case 3:
      return promesa.core.then.cljs$core$IFn$_invoke$arity$3(arguments[0], arguments[1], arguments[2]);
      break;

    default:
      throw new Error(["Invalid arity: ", cljs.core.str.cljs$core$IFn$_invoke$arity$1(arguments.length)].join(''));
  }
};

promesa.core.then.cljs$core$IFn$_invoke$arity$2 = function (p, f) {
  return promesa.protocols._then(promesa.protocols._promise(p), f);
};

promesa.core.then.cljs$core$IFn$_invoke$arity$3 = function (p, f, executor) {
  return promesa.protocols._then(promesa.protocols._promise(p), f, executor);
};

promesa.core.then.cljs$lang$maxFixedArity = 3;

promesa.core.bind = function promesa$core$bind(var_args) {
  var G__24048 = arguments.length;

  switch (G__24048) {
    case 2:
      return promesa.core.bind.cljs$core$IFn$_invoke$arity$2(arguments[0], arguments[1]);
      break;

    case 3:
      return promesa.core.bind.cljs$core$IFn$_invoke$arity$3(arguments[0], arguments[1], arguments[2]);
      break;

    default:
      throw new Error(["Invalid arity: ", cljs.core.str.cljs$core$IFn$_invoke$arity$1(arguments.length)].join(''));
  }
};

promesa.core.bind.cljs$core$IFn$_invoke$arity$2 = function (p, f) {
  return promesa.protocols._bind(promesa.protocols._promise(p), f);
};

promesa.core.bind.cljs$core$IFn$_invoke$arity$3 = function (p, f, executor) {
  return promesa.protocols._bind(promesa.protocols._promise(p), f, executor);
};

promesa.core.bind.cljs$lang$maxFixedArity = 3;
/**
 * Chains a computation `f` (function) to be executed when the promise
 *   `p` is successfully resolved.
 * 
 *   The computation will be executed in the calling thread by default;
 *   you also can provide a custom executor.
 * 
 *   Don't perform flatten on the result.
 */

promesa.core.then_SINGLEQUOTE_ = function promesa$core$then_SINGLEQUOTE_(var_args) {
  var G__24062 = arguments.length;

  switch (G__24062) {
    case 2:
      return promesa.core.then_SINGLEQUOTE_.cljs$core$IFn$_invoke$arity$2(arguments[0], arguments[1]);
      break;

    case 3:
      return promesa.core.then_SINGLEQUOTE_.cljs$core$IFn$_invoke$arity$3(arguments[0], arguments[1], arguments[2]);
      break;

    default:
      throw new Error(["Invalid arity: ", cljs.core.str.cljs$core$IFn$_invoke$arity$1(arguments.length)].join(''));
  }
};

promesa.core.then_SINGLEQUOTE_.cljs$core$IFn$_invoke$arity$2 = function (p, f) {
  return promesa.protocols._map(promesa.protocols._promise(p), f);
};

promesa.core.then_SINGLEQUOTE_.cljs$core$IFn$_invoke$arity$3 = function (p, f, executor) {
  return promesa.protocols._map(promesa.protocols._promise(p), f, executor);
};

promesa.core.then_SINGLEQUOTE_.cljs$lang$maxFixedArity = 3;
/**
 * Chains a computation `f` (function) to be executed when the promise
 *   `p` is successfully resolved.
 * 
 *   Unlike `then` this does not performs automatic promise flattening.
 *   This is designed to be used with `->>`.
 */

promesa.core.map = function promesa$core$map(var_args) {
  var G__24064 = arguments.length;

  switch (G__24064) {
    case 2:
      return promesa.core.map.cljs$core$IFn$_invoke$arity$2(arguments[0], arguments[1]);
      break;

    case 3:
      return promesa.core.map.cljs$core$IFn$_invoke$arity$3(arguments[0], arguments[1], arguments[2]);
      break;

    default:
      throw new Error(["Invalid arity: ", cljs.core.str.cljs$core$IFn$_invoke$arity$1(arguments.length)].join(''));
  }
};

promesa.core.map.cljs$core$IFn$_invoke$arity$2 = function (f, p) {
  return promesa.protocols._map(promesa.protocols._promise(p), f);
};

promesa.core.map.cljs$core$IFn$_invoke$arity$3 = function (executor, f, p) {
  return promesa.protocols._map(promesa.protocols._promise(p), f, executor);
};

promesa.core.map.cljs$lang$maxFixedArity = 3;
/**
 * Chains a computation `f` (function) to be executed when the promise
 *   `p` is successfully resolved. always expecting that `f` returns a
 *   promise that will be automatically unwrapped.
 * 
 *   This is just a stricter version of `then` with reversed arguments in
 *   the same way as `map`.
 * 
 *   This is designed to be used with `->>`.
 */

promesa.core.mapcat = function promesa$core$mapcat(var_args) {
  var G__24066 = arguments.length;

  switch (G__24066) {
    case 2:
      return promesa.core.mapcat.cljs$core$IFn$_invoke$arity$2(arguments[0], arguments[1]);
      break;

    case 3:
      return promesa.core.mapcat.cljs$core$IFn$_invoke$arity$3(arguments[0], arguments[1], arguments[2]);
      break;

    default:
      throw new Error(["Invalid arity: ", cljs.core.str.cljs$core$IFn$_invoke$arity$1(arguments.length)].join(''));
  }
};

promesa.core.mapcat.cljs$core$IFn$_invoke$arity$2 = function (f, p) {
  return promesa.protocols._bind(promesa.protocols._promise(p), f);
};

promesa.core.mapcat.cljs$core$IFn$_invoke$arity$3 = function (executor, f, p) {
  return promesa.protocols._bind(promesa.protocols._promise(p), f, executor);
};

promesa.core.mapcat.cljs$lang$maxFixedArity = 3;
/**
 * Chain variable number of computations to be executed
 *   serially. Analogous to `then` that accepts variable number of
 *   functions.
 */

promesa.core.chain = function promesa$core$chain(var_args) {
  var G__24073 = arguments.length;

  switch (G__24073) {
    case 2:
      return promesa.core.chain.cljs$core$IFn$_invoke$arity$2(arguments[0], arguments[1]);
      break;

    default:
      var args_arr__4757__auto__ = [];
      var len__4736__auto___24193 = arguments.length;
      var i__4737__auto___24194 = 0;

      while (true) {
        if (i__4737__auto___24194 < len__4736__auto___24193) {
          args_arr__4757__auto__.push(arguments[i__4737__auto___24194]);
          var G__24195 = i__4737__auto___24194 + 1;
          i__4737__auto___24194 = G__24195;
          continue;
        } else {}

        break;
      }

      var argseq__4758__auto__ = new cljs.core.IndexedSeq(args_arr__4757__auto__.slice(2), 0, null);
      return promesa.core.chain.cljs$core$IFn$_invoke$arity$variadic(arguments[0], arguments[1], argseq__4758__auto__);
  }
};

promesa.core.chain.cljs$core$IFn$_invoke$arity$2 = function (p, f) {
  return promesa.core.then.cljs$core$IFn$_invoke$arity$2(p, f);
};

promesa.core.chain.cljs$core$IFn$_invoke$arity$variadic = function (p, f, fs) {
  return cljs.core.reduce.cljs$core$IFn$_invoke$arity$3(function (p1__24067_SHARP_, p2__24068_SHARP_) {
    return promesa.core.then.cljs$core$IFn$_invoke$arity$2(p1__24067_SHARP_, p2__24068_SHARP_);
  }, p, cljs.core.cons(f, fs));
};
/** @this {Function} */


promesa.core.chain.cljs$lang$applyTo = function (seq24070) {
  var G__24071 = cljs.core.first(seq24070);
  var seq24070__$1 = cljs.core.next(seq24070);
  var G__24072 = cljs.core.first(seq24070__$1);
  var seq24070__$2 = cljs.core.next(seq24070__$1);
  var self__4723__auto__ = this;
  return self__4723__auto__.cljs$core$IFn$_invoke$arity$variadic(G__24071, G__24072, seq24070__$2);
};

promesa.core.chain.cljs$lang$maxFixedArity = 2;
/**
 * Chain variable number of computations to be executed serially. Unlike
 *   `chain` does not flattens the return value of each step (probably
 *   this is more performant than `chain`).
 */

promesa.core.chain_SINGLEQUOTE_ = function promesa$core$chain_SINGLEQUOTE_(var_args) {
  var G__24081 = arguments.length;

  switch (G__24081) {
    case 2:
      return promesa.core.chain_SINGLEQUOTE_.cljs$core$IFn$_invoke$arity$2(arguments[0], arguments[1]);
      break;

    default:
      var args_arr__4757__auto__ = [];
      var len__4736__auto___24197 = arguments.length;
      var i__4737__auto___24198 = 0;

      while (true) {
        if (i__4737__auto___24198 < len__4736__auto___24197) {
          args_arr__4757__auto__.push(arguments[i__4737__auto___24198]);
          var G__24199 = i__4737__auto___24198 + 1;
          i__4737__auto___24198 = G__24199;
          continue;
        } else {}

        break;
      }

      var argseq__4758__auto__ = new cljs.core.IndexedSeq(args_arr__4757__auto__.slice(2), 0, null);
      return promesa.core.chain_SINGLEQUOTE_.cljs$core$IFn$_invoke$arity$variadic(arguments[0], arguments[1], argseq__4758__auto__);
  }
};

promesa.core.chain_SINGLEQUOTE_.cljs$core$IFn$_invoke$arity$2 = function (p, f) {
  return promesa.core.then_SINGLEQUOTE_.cljs$core$IFn$_invoke$arity$2(p, f);
};

promesa.core.chain_SINGLEQUOTE_.cljs$core$IFn$_invoke$arity$variadic = function (p, f, fs) {
  return cljs.core.reduce.cljs$core$IFn$_invoke$arity$3(promesa.protocols._map, promesa.protocols._promise(p), cljs.core.cons(f, fs));
};
/** @this {Function} */


promesa.core.chain_SINGLEQUOTE_.cljs$lang$applyTo = function (seq24078) {
  var G__24079 = cljs.core.first(seq24078);
  var seq24078__$1 = cljs.core.next(seq24078);
  var G__24080 = cljs.core.first(seq24078__$1);
  var seq24078__$2 = cljs.core.next(seq24078__$1);
  var self__4723__auto__ = this;
  return self__4723__auto__.cljs$core$IFn$_invoke$arity$variadic(G__24079, G__24080, seq24078__$2);
};

promesa.core.chain_SINGLEQUOTE_.cljs$lang$maxFixedArity = 2;
/**
 * Executes `f` when the promise `p` is resolved or is rejected. Returns
 *   a promise resolved with the return value of `f` function.
 */

promesa.core.handle = function promesa$core$handle(var_args) {
  var G__24084 = arguments.length;

  switch (G__24084) {
    case 2:
      return promesa.core.handle.cljs$core$IFn$_invoke$arity$2(arguments[0], arguments[1]);
      break;

    case 3:
      return promesa.core.handle.cljs$core$IFn$_invoke$arity$3(arguments[0], arguments[1], arguments[2]);
      break;

    default:
      throw new Error(["Invalid arity: ", cljs.core.str.cljs$core$IFn$_invoke$arity$1(arguments.length)].join(''));
  }
};

promesa.core.handle.cljs$core$IFn$_invoke$arity$2 = function (p, f) {
  return promesa.protocols._handle(promesa.protocols._promise(p), f);
};

promesa.core.handle.cljs$core$IFn$_invoke$arity$3 = function (p, f, executor) {
  return promesa.protocols._handle(promesa.protocols._promise(p), f, executor);
};

promesa.core.handle.cljs$lang$maxFixedArity = 3;
/**
 * Attach a potentially side-effectful handler to promise that will be
 *   executed independently if promise is resolved or rejected.
 * 
 *   Returns the original promise and the return value of `f` function is
 *   ignored.
 */

promesa.core.finally$ = function promesa$core$finally(var_args) {
  var G__24086 = arguments.length;

  switch (G__24086) {
    case 2:
      return promesa.core.finally$.cljs$core$IFn$_invoke$arity$2(arguments[0], arguments[1]);
      break;

    case 3:
      return promesa.core.finally$.cljs$core$IFn$_invoke$arity$3(arguments[0], arguments[1], arguments[2]);
      break;

    default:
      throw new Error(["Invalid arity: ", cljs.core.str.cljs$core$IFn$_invoke$arity$1(arguments.length)].join(''));
  }
};

promesa.core.finally$.cljs$core$IFn$_invoke$arity$2 = function (p, f) {
  return promesa.protocols._finally(promesa.protocols._promise(p), f);
};

promesa.core.finally$.cljs$core$IFn$_invoke$arity$3 = function (p, f, executor) {
  return promesa.protocols._finally(promesa.protocols._promise(p), f, executor);
};

promesa.core.finally$.cljs$lang$maxFixedArity = 3;
/**
 * Executes `f` when the promise `p` is rejected. Returns a promise
 *   resolved with the return value of `f` function handler.
 */

promesa.core.catch$ = function promesa$core$catch(var_args) {
  var G__24089 = arguments.length;

  switch (G__24089) {
    case 2:
      return promesa.core.catch$.cljs$core$IFn$_invoke$arity$2(arguments[0], arguments[1]);
      break;

    case 3:
      return promesa.core.catch$.cljs$core$IFn$_invoke$arity$3(arguments[0], arguments[1], arguments[2]);
      break;

    default:
      throw new Error(["Invalid arity: ", cljs.core.str.cljs$core$IFn$_invoke$arity$1(arguments.length)].join(''));
  }
};

promesa.core.catch$.cljs$core$IFn$_invoke$arity$2 = function (p, f) {
  return promesa.protocols._thenErr(promesa.protocols._promise(p), f);
};

promesa.core.catch$.cljs$core$IFn$_invoke$arity$3 = function (p, pred_or_type, f) {
  var accept_QMARK_ = cljs.core.ifn_QMARK_(pred_or_type) ? pred_or_type : function (p1__24087_SHARP_) {
    return p1__24087_SHARP_ instanceof pred_or_type;
  };
  return promesa.protocols._thenErr(promesa.protocols._promise(p), function (e) {
    if (cljs.core.truth_(accept_QMARK_.cljs$core$IFn$_invoke$arity$1 ? accept_QMARK_.cljs$core$IFn$_invoke$arity$1(e) : accept_QMARK_.call(null, e))) {
      return f.cljs$core$IFn$_invoke$arity$1 ? f.cljs$core$IFn$_invoke$arity$1(e) : f.call(null, e);
    } else {
      return promesa.impl.rejected(e);
    }
  });
};

promesa.core.catch$.cljs$lang$maxFixedArity = 3;
/**
 * Executes `f` when the promise `p` is rejected. Returns a promise
 *   resolved with the return value of `f` function handler.
 */

promesa.core.catch_SINGLEQUOTE_ = function promesa$core$catch_SINGLEQUOTE_(var_args) {
  var G__24092 = arguments.length;

  switch (G__24092) {
    case 2:
      return promesa.core.catch_SINGLEQUOTE_.cljs$core$IFn$_invoke$arity$2(arguments[0], arguments[1]);
      break;

    case 3:
      return promesa.core.catch_SINGLEQUOTE_.cljs$core$IFn$_invoke$arity$3(arguments[0], arguments[1], arguments[2]);
      break;

    default:
      throw new Error(["Invalid arity: ", cljs.core.str.cljs$core$IFn$_invoke$arity$1(arguments.length)].join(''));
  }
};

promesa.core.catch_SINGLEQUOTE_.cljs$core$IFn$_invoke$arity$2 = function (p, f) {
  return promesa.protocols._mapErr(promesa.protocols._promise(p), f);
};

promesa.core.catch_SINGLEQUOTE_.cljs$core$IFn$_invoke$arity$3 = function (p, pred_or_type, f) {
  var accept_QMARK_ = cljs.core.ifn_QMARK_(pred_or_type) ? pred_or_type : function (p1__24090_SHARP_) {
    return p1__24090_SHARP_ instanceof pred_or_type;
  };
  return promesa.protocols._mapErr(promesa.protocols._promise(p), function (e) {
    if (cljs.core.truth_(accept_QMARK_.cljs$core$IFn$_invoke$arity$1 ? accept_QMARK_.cljs$core$IFn$_invoke$arity$1(e) : accept_QMARK_.call(null, e))) {
      return f.cljs$core$IFn$_invoke$arity$1 ? f.cljs$core$IFn$_invoke$arity$1(e) : f.call(null, e);
    } else {
      return promesa.impl.rejected(e);
    }
  });
};

promesa.core.catch_SINGLEQUOTE_.cljs$lang$maxFixedArity = 3;
/**
 * Same as `catch` but with parameters inverted.
 */

promesa.core.error = function promesa$core$error(var_args) {
  var G__24094 = arguments.length;

  switch (G__24094) {
    case 2:
      return promesa.core.error.cljs$core$IFn$_invoke$arity$2(arguments[0], arguments[1]);
      break;

    case 3:
      return promesa.core.error.cljs$core$IFn$_invoke$arity$3(arguments[0], arguments[1], arguments[2]);
      break;

    default:
      throw new Error(["Invalid arity: ", cljs.core.str.cljs$core$IFn$_invoke$arity$1(arguments.length)].join(''));
  }
};

promesa.core.error.cljs$core$IFn$_invoke$arity$2 = function (f, p) {
  return promesa.core.catch$.cljs$core$IFn$_invoke$arity$2(p, f);
};

promesa.core.error.cljs$core$IFn$_invoke$arity$3 = function (f, type, p) {
  return promesa.core.catch$.cljs$core$IFn$_invoke$arity$3(p, type, f);
};

promesa.core.error.cljs$lang$maxFixedArity = 3;
/**
 * A short alias for `error` function.
 */

promesa.core.err = promesa.core.error;
/**
 * Given an array of promises, return a promise
 *   that is fulfilled  when all the items in the
 *   array are fulfilled.
 * 
 *   Example:
 * 
 *   (-> (all [(promise :first-promise)
 *          (promise :second-promise)]
 *    (then (fn [[first-result second-result]]))
 *     (println (str first-result ", " second-result)
 * 
 *   Will print out
 *   :first-promise, :second-promise.
 * 
 *   If at least one of the promises is rejected, the resulting promise will be
 *   rejected.
 */

promesa.core.all = function promesa$core$all(promises) {
  return promesa.core.then_SINGLEQUOTE_.cljs$core$IFn$_invoke$arity$2(promesa.impl._STAR_default_promise_STAR_.all(cljs.core.into_array.cljs$core$IFn$_invoke$arity$1(promises)), cljs.core.vec);
};

promesa.core.race = function promesa$core$race(promises) {
  return promesa.impl._STAR_default_promise_STAR_.race(cljs.core.into_array.cljs$core$IFn$_invoke$arity$1(cljs.core.map.cljs$core$IFn$_invoke$arity$2(promesa.protocols._promise, promises)));
};
/**
 * Given an array of promises, return a promise that is fulfilled when
 *   first one item in the array is fulfilled.
 */


promesa.core.any = function promesa$core$any(var_args) {
  var G__24109 = arguments.length;

  switch (G__24109) {
    case 1:
      return promesa.core.any.cljs$core$IFn$_invoke$arity$1(arguments[0]);
      break;

    case 2:
      return promesa.core.any.cljs$core$IFn$_invoke$arity$2(arguments[0], arguments[1]);
      break;

    default:
      throw new Error(["Invalid arity: ", cljs.core.str.cljs$core$IFn$_invoke$arity$1(arguments.length)].join(''));
  }
};

promesa.core.any.cljs$core$IFn$_invoke$arity$1 = function (promises) {
  return promesa.core.any.cljs$core$IFn$_invoke$arity$2(promises, new cljs.core.Keyword("promesa.core", "default", "promesa.core/default", 1773193826));
};

promesa.core.any.cljs$core$IFn$_invoke$arity$2 = function (promises, default$) {
  var state = cljs.core.atom.cljs$core$IFn$_invoke$arity$1(new cljs.core.PersistentArrayMap(null, 3, [new cljs.core.Keyword(null, "resolved", "resolved", 968763567), false, new cljs.core.Keyword(null, "counter", "counter", 804008177), cljs.core.count(promises), new cljs.core.Keyword(null, "rejections", "rejections", -1620899911), cljs.core.PersistentVector.EMPTY], null));
  return promesa.core.create.cljs$core$IFn$_invoke$arity$1(function (resolve, reject) {
    var seq__24113 = cljs.core.seq(promises);
    var chunk__24114 = null;
    var count__24115 = 0;
    var i__24116 = 0;

    while (true) {
      if (i__24116 < count__24115) {
        var p = chunk__24114.cljs$core$IIndexed$_nth$arity$2(null, i__24116);
        promesa.core.catch$.cljs$core$IFn$_invoke$arity$2(promesa.core.then.cljs$core$IFn$_invoke$arity$2(promesa.protocols._promise(p), function (seq__24113, chunk__24114, count__24115, i__24116, p, state) {
          return function (v) {
            if (cljs.core.truth_(new cljs.core.Keyword(null, "resolved", "resolved", 968763567).cljs$core$IFn$_invoke$arity$1(cljs.core.deref(state)))) {
              return null;
            } else {
              cljs.core.swap_BANG_.cljs$core$IFn$_invoke$arity$2(state, function (seq__24113, chunk__24114, count__24115, i__24116, p, state) {
                return function (state__$1) {
                  return cljs.core.update.cljs$core$IFn$_invoke$arity$3(cljs.core.assoc.cljs$core$IFn$_invoke$arity$3(state__$1, new cljs.core.Keyword(null, "resolved", "resolved", 968763567), true), new cljs.core.Keyword(null, "counter", "counter", 804008177), cljs.core.dec);
                };
              }(seq__24113, chunk__24114, count__24115, i__24116, p, state));
              return resolve.cljs$core$IFn$_invoke$arity$1 ? resolve.cljs$core$IFn$_invoke$arity$1(v) : resolve.call(null, v);
            }
          };
        }(seq__24113, chunk__24114, count__24115, i__24116, p, state)), function (seq__24113, chunk__24114, count__24115, i__24116, p, state) {
          return function (e) {
            cljs.core.swap_BANG_.cljs$core$IFn$_invoke$arity$2(state, function (seq__24113, chunk__24114, count__24115, i__24116, p, state) {
              return function (state__$1) {
                return cljs.core.update.cljs$core$IFn$_invoke$arity$4(cljs.core.update.cljs$core$IFn$_invoke$arity$3(state__$1, new cljs.core.Keyword(null, "counter", "counter", 804008177), cljs.core.dec), new cljs.core.Keyword(null, "rejections", "rejections", -1620899911), cljs.core.conj, e);
              };
            }(seq__24113, chunk__24114, count__24115, i__24116, p, state));
            var map__24128 = cljs.core.deref(state);
            var map__24128__$1 = (!(map__24128 == null) ? map__24128.cljs$lang$protocol_mask$partition0$ & 64 || cljs.core.PROTOCOL_SENTINEL === map__24128.cljs$core$ISeq$ ? true : false : false) ? cljs.core.apply.cljs$core$IFn$_invoke$arity$2(cljs.core.hash_map, map__24128) : map__24128;
            var resolved = cljs.core.get.cljs$core$IFn$_invoke$arity$2(map__24128__$1, new cljs.core.Keyword(null, "resolved", "resolved", 968763567));
            var counter = cljs.core.get.cljs$core$IFn$_invoke$arity$2(map__24128__$1, new cljs.core.Keyword(null, "counter", "counter", 804008177));
            var rejections = cljs.core.get.cljs$core$IFn$_invoke$arity$2(map__24128__$1, new cljs.core.Keyword(null, "rejections", "rejections", -1620899911));

            if (cljs.core.not(resolved) && cljs.core._EQ_.cljs$core$IFn$_invoke$arity$2(counter, 0)) {
              if (cljs.core._EQ_.cljs$core$IFn$_invoke$arity$2(default$, new cljs.core.Keyword("promesa.core", "default", "promesa.core/default", 1773193826))) {
                var G__24132 = cljs.core.ex_info.cljs$core$IFn$_invoke$arity$2("No promises resolved", new cljs.core.PersistentArrayMap(null, 1, [new cljs.core.Keyword(null, "rejections", "rejections", -1620899911), rejections], null));
                return reject.cljs$core$IFn$_invoke$arity$1 ? reject.cljs$core$IFn$_invoke$arity$1(G__24132) : reject.call(null, G__24132);
              } else {
                return resolve.cljs$core$IFn$_invoke$arity$1 ? resolve.cljs$core$IFn$_invoke$arity$1(default$) : resolve.call(null, default$);
              }
            } else {
              return null;
            }
          };
        }(seq__24113, chunk__24114, count__24115, i__24116, p, state));
        var G__24206 = seq__24113;
        var G__24207 = chunk__24114;
        var G__24208 = count__24115;
        var G__24209 = i__24116 + 1;
        seq__24113 = G__24206;
        chunk__24114 = G__24207;
        count__24115 = G__24208;
        i__24116 = G__24209;
        continue;
      } else {
        var temp__5804__auto__ = cljs.core.seq(seq__24113);

        if (temp__5804__auto__) {
          var seq__24113__$1 = temp__5804__auto__;

          if (cljs.core.chunked_seq_QMARK_(seq__24113__$1)) {
            var c__4556__auto__ = cljs.core.chunk_first(seq__24113__$1);
            var G__24210 = cljs.core.chunk_rest(seq__24113__$1);
            var G__24211 = c__4556__auto__;
            var G__24212 = cljs.core.count(c__4556__auto__);
            var G__24213 = 0;
            seq__24113 = G__24210;
            chunk__24114 = G__24211;
            count__24115 = G__24212;
            i__24116 = G__24213;
            continue;
          } else {
            var p = cljs.core.first(seq__24113__$1);
            promesa.core.catch$.cljs$core$IFn$_invoke$arity$2(promesa.core.then.cljs$core$IFn$_invoke$arity$2(promesa.protocols._promise(p), function (seq__24113, chunk__24114, count__24115, i__24116, p, seq__24113__$1, temp__5804__auto__, state) {
              return function (v) {
                if (cljs.core.truth_(new cljs.core.Keyword(null, "resolved", "resolved", 968763567).cljs$core$IFn$_invoke$arity$1(cljs.core.deref(state)))) {
                  return null;
                } else {
                  cljs.core.swap_BANG_.cljs$core$IFn$_invoke$arity$2(state, function (seq__24113, chunk__24114, count__24115, i__24116, p, seq__24113__$1, temp__5804__auto__, state) {
                    return function (state__$1) {
                      return cljs.core.update.cljs$core$IFn$_invoke$arity$3(cljs.core.assoc.cljs$core$IFn$_invoke$arity$3(state__$1, new cljs.core.Keyword(null, "resolved", "resolved", 968763567), true), new cljs.core.Keyword(null, "counter", "counter", 804008177), cljs.core.dec);
                    };
                  }(seq__24113, chunk__24114, count__24115, i__24116, p, seq__24113__$1, temp__5804__auto__, state));
                  return resolve.cljs$core$IFn$_invoke$arity$1 ? resolve.cljs$core$IFn$_invoke$arity$1(v) : resolve.call(null, v);
                }
              };
            }(seq__24113, chunk__24114, count__24115, i__24116, p, seq__24113__$1, temp__5804__auto__, state)), function (seq__24113, chunk__24114, count__24115, i__24116, p, seq__24113__$1, temp__5804__auto__, state) {
              return function (e) {
                cljs.core.swap_BANG_.cljs$core$IFn$_invoke$arity$2(state, function (seq__24113, chunk__24114, count__24115, i__24116, p, seq__24113__$1, temp__5804__auto__, state) {
                  return function (state__$1) {
                    return cljs.core.update.cljs$core$IFn$_invoke$arity$4(cljs.core.update.cljs$core$IFn$_invoke$arity$3(state__$1, new cljs.core.Keyword(null, "counter", "counter", 804008177), cljs.core.dec), new cljs.core.Keyword(null, "rejections", "rejections", -1620899911), cljs.core.conj, e);
                  };
                }(seq__24113, chunk__24114, count__24115, i__24116, p, seq__24113__$1, temp__5804__auto__, state));
                var map__24137 = cljs.core.deref(state);
                var map__24137__$1 = (!(map__24137 == null) ? map__24137.cljs$lang$protocol_mask$partition0$ & 64 || cljs.core.PROTOCOL_SENTINEL === map__24137.cljs$core$ISeq$ ? true : false : false) ? cljs.core.apply.cljs$core$IFn$_invoke$arity$2(cljs.core.hash_map, map__24137) : map__24137;
                var resolved = cljs.core.get.cljs$core$IFn$_invoke$arity$2(map__24137__$1, new cljs.core.Keyword(null, "resolved", "resolved", 968763567));
                var counter = cljs.core.get.cljs$core$IFn$_invoke$arity$2(map__24137__$1, new cljs.core.Keyword(null, "counter", "counter", 804008177));
                var rejections = cljs.core.get.cljs$core$IFn$_invoke$arity$2(map__24137__$1, new cljs.core.Keyword(null, "rejections", "rejections", -1620899911));

                if (cljs.core.not(resolved) && cljs.core._EQ_.cljs$core$IFn$_invoke$arity$2(counter, 0)) {
                  if (cljs.core._EQ_.cljs$core$IFn$_invoke$arity$2(default$, new cljs.core.Keyword("promesa.core", "default", "promesa.core/default", 1773193826))) {
                    var G__24139 = cljs.core.ex_info.cljs$core$IFn$_invoke$arity$2("No promises resolved", new cljs.core.PersistentArrayMap(null, 1, [new cljs.core.Keyword(null, "rejections", "rejections", -1620899911), rejections], null));
                    return reject.cljs$core$IFn$_invoke$arity$1 ? reject.cljs$core$IFn$_invoke$arity$1(G__24139) : reject.call(null, G__24139);
                  } else {
                    return resolve.cljs$core$IFn$_invoke$arity$1 ? resolve.cljs$core$IFn$_invoke$arity$1(default$) : resolve.call(null, default$);
                  }
                } else {
                  return null;
                }
              };
            }(seq__24113, chunk__24114, count__24115, i__24116, p, seq__24113__$1, temp__5804__auto__, state));
            var G__24214 = cljs.core.next(seq__24113__$1);
            var G__24215 = null;
            var G__24216 = 0;
            var G__24217 = 0;
            seq__24113 = G__24214;
            chunk__24114 = G__24215;
            count__24115 = G__24216;
            i__24116 = G__24217;
            continue;
          }
        } else {
          return null;
        }
      }

      break;
    }
  });
};

promesa.core.any.cljs$lang$maxFixedArity = 2;
/**
 * A promise aware run! function.
 */

promesa.core.run_BANG_ = function promesa$core$run_BANG_(var_args) {
  var G__24143 = arguments.length;

  switch (G__24143) {
    case 2:
      return promesa.core.run_BANG_.cljs$core$IFn$_invoke$arity$2(arguments[0], arguments[1]);
      break;

    case 3:
      return promesa.core.run_BANG_.cljs$core$IFn$_invoke$arity$3(arguments[0], arguments[1], arguments[2]);
      break;

    default:
      throw new Error(["Invalid arity: ", cljs.core.str.cljs$core$IFn$_invoke$arity$1(arguments.length)].join(''));
  }
};

promesa.core.run_BANG_.cljs$core$IFn$_invoke$arity$2 = function (f, coll) {
  return promesa.core.run_BANG_.cljs$core$IFn$_invoke$arity$3(f, coll, promesa.exec.current_thread_executor);
};

promesa.core.run_BANG_.cljs$core$IFn$_invoke$arity$3 = function (f, coll, executor) {
  return cljs.core.reduce.cljs$core$IFn$_invoke$arity$3(function (p1__24140_SHARP_, p2__24141_SHARP_) {
    return promesa.core.then.cljs$core$IFn$_invoke$arity$2(p1__24140_SHARP_, function (_) {
      return f.cljs$core$IFn$_invoke$arity$1 ? f.cljs$core$IFn$_invoke$arity$1(p2__24141_SHARP_) : f.call(null, p2__24141_SHARP_);
    });
  }, promesa.core.promise.cljs$core$IFn$_invoke$arity$2(null, executor), coll);
};

promesa.core.run_BANG_.cljs$lang$maxFixedArity = 3;
/**
 * Cancel the promise.
 */

promesa.core.cancel_BANG_ = function promesa$core$cancel_BANG_(p) {
  promesa.protocols._cancel_BANG_(p);

  return p;
};
/**
 * Return true if `v` is a cancelled promise.
 */


promesa.core.cancelled_QMARK_ = function promesa$core$cancelled_QMARK_(v) {
  return promesa.protocols._cancelled_QMARK_(v);
};
/**
 * Resolve a completable promise with a value.
 */


promesa.core.resolve_BANG_ = function promesa$core$resolve_BANG_(var_args) {
  var G__24148 = arguments.length;

  switch (G__24148) {
    case 1:
      return promesa.core.resolve_BANG_.cljs$core$IFn$_invoke$arity$1(arguments[0]);
      break;

    case 2:
      return promesa.core.resolve_BANG_.cljs$core$IFn$_invoke$arity$2(arguments[0], arguments[1]);
      break;

    default:
      throw new Error(["Invalid arity: ", cljs.core.str.cljs$core$IFn$_invoke$arity$1(arguments.length)].join(''));
  }
};

promesa.core.resolve_BANG_.cljs$core$IFn$_invoke$arity$1 = function (o) {
  return promesa.protocols._resolve_BANG_(o, null);
};

promesa.core.resolve_BANG_.cljs$core$IFn$_invoke$arity$2 = function (o, v) {
  return promesa.protocols._resolve_BANG_(o, v);
};

promesa.core.resolve_BANG_.cljs$lang$maxFixedArity = 2;
/**
 * Reject a completable promise with an error.
 */

promesa.core.reject_BANG_ = function promesa$core$reject_BANG_(p, e) {
  return promesa.protocols._reject_BANG_(p, e);
};
/**
 * Given a function that accepts a callback as the last argument return other
 *   function that returns a promise. Callback is expected to take single
 *   parameter (result of a computation).
 */


promesa.core.promisify = function promesa$core$promisify(callable) {
  return function () {
    var G__24220__delegate = function G__24220__delegate(args) {
      return promesa.core.create.cljs$core$IFn$_invoke$arity$1(function (resolve, reject) {
        var args__$1 = cljs.core.conj.cljs$core$IFn$_invoke$arity$2(cljs.core.vec(args), resolve);

        try {
          return cljs.core.apply.cljs$core$IFn$_invoke$arity$2(callable, args__$1);
        } catch (e24155) {
          if (e24155 instanceof Error) {
            var e = e24155;
            return reject.cljs$core$IFn$_invoke$arity$1 ? reject.cljs$core$IFn$_invoke$arity$1(e) : reject.call(null, e);
          } else {
            throw e24155;
          }
        }
      });
    };

    var G__24220 = function G__24220(var_args) {
      var args = null;

      if (arguments.length > 0) {
        var G__24221__i = 0,
            G__24221__a = new Array(arguments.length - 0);

        while (G__24221__i < G__24221__a.length) {
          G__24221__a[G__24221__i] = arguments[G__24221__i + 0];
          ++G__24221__i;
        }

        args = new cljs.core.IndexedSeq(G__24221__a, 0, null);
      }

      return G__24220__delegate.call(this, args);
    };

    G__24220.cljs$lang$maxFixedArity = 0;

    G__24220.cljs$lang$applyTo = function (arglist__24222) {
      var args = cljs.core.seq(arglist__24222);
      return G__24220__delegate(args);
    };

    G__24220.cljs$core$IFn$_invoke$arity$variadic = G__24220__delegate;
    return G__24220;
  }();
};
/**
 * @constructor
 */


promesa.core.TimeoutException = function promesa$core$TimeoutException(message) {
  var it = this;
  Error.call(it, message, cljs.core.PersistentArrayMap.EMPTY, null);
  return it;
};

goog.inherits(promesa.core.TimeoutException, Error);
/**
 * Returns a cancellable promise that will be fulfilled with this
 *   promise's fulfillment value or rejection reason.  However, if this
 *   promise is not fulfilled or rejected within `ms` milliseconds, the
 *   returned promise is cancelled with a TimeoutError
 */

promesa.core.timeout = function promesa$core$timeout(var_args) {
  var G__24163 = arguments.length;

  switch (G__24163) {
    case 2:
      return promesa.core.timeout.cljs$core$IFn$_invoke$arity$2(arguments[0], arguments[1]);
      break;

    case 3:
      return promesa.core.timeout.cljs$core$IFn$_invoke$arity$3(arguments[0], arguments[1], arguments[2]);
      break;

    case 4:
      return promesa.core.timeout.cljs$core$IFn$_invoke$arity$4(arguments[0], arguments[1], arguments[2], arguments[3]);
      break;

    default:
      throw new Error(["Invalid arity: ", cljs.core.str.cljs$core$IFn$_invoke$arity$1(arguments.length)].join(''));
  }
};

promesa.core.timeout.cljs$core$IFn$_invoke$arity$2 = function (p, t) {
  return promesa.core.timeout.cljs$core$IFn$_invoke$arity$4(p, t, new cljs.core.Keyword("promesa.core", "default", "promesa.core/default", 1773193826), promesa.exec.default_scheduler);
};

promesa.core.timeout.cljs$core$IFn$_invoke$arity$3 = function (p, t, v) {
  return promesa.core.timeout.cljs$core$IFn$_invoke$arity$4(p, t, v, promesa.exec.default_scheduler);
};

promesa.core.timeout.cljs$core$IFn$_invoke$arity$4 = function (p, t, v, scheduler) {
  var timeout = promesa.core.deferred();
  var tid = promesa.exec.schedule_BANG_.cljs$core$IFn$_invoke$arity$3(scheduler, t, function () {
    if (cljs.core._EQ_.cljs$core$IFn$_invoke$arity$2(v, new cljs.core.Keyword("promesa.core", "default", "promesa.core/default", 1773193826))) {
      return promesa.core.reject_BANG_(timeout, new promesa.core.TimeoutException("Operation timed out."));
    } else {
      return promesa.core.resolve_BANG_.cljs$core$IFn$_invoke$arity$2(timeout, v);
    }
  });
  return promesa.core.race(new cljs.core.PersistentVector(null, 2, 5, cljs.core.PersistentVector.EMPTY_NODE, [promesa.core.finally$.cljs$core$IFn$_invoke$arity$2(p, function (_, ___$1) {
    return promesa.protocols._cancel_BANG_(tid);
  }), timeout], null));
};

promesa.core.timeout.cljs$lang$maxFixedArity = 4;
/**
 * Given a timeout in miliseconds and optional value, returns a promise
 *   that will fulfilled with provided value (or nil) after the time is
 *   reached.
 */

promesa.core.delay = function promesa$core$delay(var_args) {
  var G__24165 = arguments.length;

  switch (G__24165) {
    case 1:
      return promesa.core.delay.cljs$core$IFn$_invoke$arity$1(arguments[0]);
      break;

    case 2:
      return promesa.core.delay.cljs$core$IFn$_invoke$arity$2(arguments[0], arguments[1]);
      break;

    case 3:
      return promesa.core.delay.cljs$core$IFn$_invoke$arity$3(arguments[0], arguments[1], arguments[2]);
      break;

    default:
      throw new Error(["Invalid arity: ", cljs.core.str.cljs$core$IFn$_invoke$arity$1(arguments.length)].join(''));
  }
};

promesa.core.delay.cljs$core$IFn$_invoke$arity$1 = function (t) {
  return promesa.core.delay.cljs$core$IFn$_invoke$arity$3(t, null, promesa.exec.default_scheduler);
};

promesa.core.delay.cljs$core$IFn$_invoke$arity$2 = function (t, v) {
  return promesa.core.delay.cljs$core$IFn$_invoke$arity$3(t, v, promesa.exec.default_scheduler);
};

promesa.core.delay.cljs$core$IFn$_invoke$arity$3 = function (t, v, scheduler) {
  var d = promesa.core.deferred();
  promesa.exec.schedule_BANG_.cljs$core$IFn$_invoke$arity$3(scheduler, t, function () {
    return promesa.core.resolve_BANG_.cljs$core$IFn$_invoke$arity$2(d, v);
  });
  return d;
};

promesa.core.delay.cljs$lang$maxFixedArity = 3;
promesa.core._STAR_loop_run_fn_STAR_ = promesa.exec.run_BANG_;
Object.defineProperty(module.exports, "timeout", {
  enumerable: false,
  get: function get() {
    return promesa.core.timeout;
  }
});
Object.defineProperty(module.exports, "deferred_QMARK_", {
  enumerable: false,
  get: function get() {
    return promesa.core.deferred_QMARK_;
  }
});
Object.defineProperty(module.exports, "map", {
  enumerable: false,
  get: function get() {
    return promesa.core.map;
  }
});
Object.defineProperty(module.exports, "delay", {
  enumerable: false,
  get: function get() {
    return promesa.core.delay;
  }
});
Object.defineProperty(module.exports, "resolved_QMARK_", {
  enumerable: false,
  get: function get() {
    return promesa.core.resolved_QMARK_;
  }
});
Object.defineProperty(module.exports, "mapcat", {
  enumerable: false,
  get: function get() {
    return promesa.core.mapcat;
  }
});
Object.defineProperty(module.exports, "cancelled_QMARK_", {
  enumerable: false,
  get: function get() {
    return promesa.core.cancelled_QMARK_;
  }
});
Object.defineProperty(module.exports, "bind", {
  enumerable: false,
  get: function get() {
    return promesa.core.bind;
  }
});
Object.defineProperty(module.exports, "resolve_BANG_", {
  enumerable: false,
  get: function get() {
    return promesa.core.resolve_BANG_;
  }
});
Object.defineProperty(module.exports, "any", {
  enumerable: false,
  get: function get() {
    return promesa.core.any;
  }
});
Object.defineProperty(module.exports, "finally$", {
  enumerable: false,
  get: function get() {
    return promesa.core.finally$;
  }
});
Object.defineProperty(module.exports, "then_SINGLEQUOTE_", {
  enumerable: false,
  get: function get() {
    return promesa.core.then_SINGLEQUOTE_;
  }
});
Object.defineProperty(module.exports, "chain_SINGLEQUOTE_", {
  enumerable: false,
  get: function get() {
    return promesa.core.chain_SINGLEQUOTE_;
  }
});
Object.defineProperty(module.exports, "wrap", {
  enumerable: false,
  get: function get() {
    return promesa.core.wrap;
  }
});
Object.defineProperty(module.exports, "promisify", {
  enumerable: false,
  get: function get() {
    return promesa.core.promisify;
  }
});
Object.defineProperty(module.exports, "rejected", {
  enumerable: false,
  get: function get() {
    return promesa.core.rejected;
  }
});
Object.defineProperty(module.exports, "promise", {
  enumerable: false,
  get: function get() {
    return promesa.core.promise;
  }
});
Object.defineProperty(module.exports, "create", {
  enumerable: false,
  get: function get() {
    return promesa.core.create;
  }
});
Object.defineProperty(module.exports, "race", {
  enumerable: false,
  get: function get() {
    return promesa.core.race;
  }
});
Object.defineProperty(module.exports, "cancel_BANG_", {
  enumerable: false,
  get: function get() {
    return promesa.core.cancel_BANG_;
  }
});
Object.defineProperty(module.exports, "thenable_QMARK_", {
  enumerable: false,
  get: function get() {
    return promesa.core.thenable_QMARK_;
  }
});
Object.defineProperty(module.exports, "TimeoutException", {
  enumerable: false,
  get: function get() {
    return promesa.core.TimeoutException;
  }
});
Object.defineProperty(module.exports, "done_QMARK_", {
  enumerable: false,
  get: function get() {
    return promesa.core.done_QMARK_;
  }
});
Object.defineProperty(module.exports, "err", {
  enumerable: false,
  get: function get() {
    return promesa.core.err;
  }
});
Object.defineProperty(module.exports, "catch_SINGLEQUOTE_", {
  enumerable: false,
  get: function get() {
    return promesa.core.catch_SINGLEQUOTE_;
  }
});
Object.defineProperty(module.exports, "run_BANG_", {
  enumerable: false,
  get: function get() {
    return promesa.core.run_BANG_;
  }
});
Object.defineProperty(module.exports, "all", {
  enumerable: false,
  get: function get() {
    return promesa.core.all;
  }
});
Object.defineProperty(module.exports, "reject_BANG_", {
  enumerable: false,
  get: function get() {
    return promesa.core.reject_BANG_;
  }
});
Object.defineProperty(module.exports, "promise_QMARK_", {
  enumerable: false,
  get: function get() {
    return promesa.core.promise_QMARK_;
  }
});
Object.defineProperty(module.exports, "resolved", {
  enumerable: false,
  get: function get() {
    return promesa.core.resolved;
  }
});
Object.defineProperty(module.exports, "deferred", {
  enumerable: false,
  get: function get() {
    return promesa.core.deferred;
  }
});
Object.defineProperty(module.exports, "_STAR_loop_run_fn_STAR_", {
  enumerable: false,
  get: function get() {
    return promesa.core._STAR_loop_run_fn_STAR_;
  }
});
Object.defineProperty(module.exports, "catch$", {
  enumerable: false,
  get: function get() {
    return promesa.core.catch$;
  }
});
Object.defineProperty(module.exports, "chain", {
  enumerable: false,
  get: function get() {
    return promesa.core.chain;
  }
});
Object.defineProperty(module.exports, "handle", {
  enumerable: false,
  get: function get() {
    return promesa.core.handle;
  }
});
Object.defineProperty(module.exports, "rejected_QMARK_", {
  enumerable: false,
  get: function get() {
    return promesa.core.rejected_QMARK_;
  }
});
Object.defineProperty(module.exports, "then", {
  enumerable: false,
  get: function get() {
    return promesa.core.then;
  }
});
Object.defineProperty(module.exports, "extract", {
  enumerable: false,
  get: function get() {
    return promesa.core.extract;
  }
});
Object.defineProperty(module.exports, "error", {
  enumerable: false,
  get: function get() {
    return promesa.core.error;
  }
});
Object.defineProperty(module.exports, "pending_QMARK_", {
  enumerable: false,
  get: function get() {
    return promesa.core.pending_QMARK_;
  }
});